import React from 'react';
import classNames from 'classnames/bind';
import styles from './index.pcss';
import { replaceWithJioCDN } from '../../../../utils/imageHandling';

interface EventIconProps {
  eventIcon: string;
}

const cx = classNames.bind(styles);

const EventIcon = (props: EventIconProps): JSX.Element | null => {
  const { eventIcon = '' } = props;

  if (!eventIcon) return null;

  return (
    <div className={cx('circle-logo', 'sale-logo')}>
      <img src={replaceWithJioCDN(eventIcon)} alt="sale icon" />
    </div>
  );
};

export default EventIcon;
